import React from "react";
import styled from "styled-components";
import AboutBanner from "../../components/Website/AboutBanner";
import AboutQuote from "../../components/Website/AboutQuote";
import Footer from "../../components/Website/Footer";
import SubscribeWaitList from "../../components/Website/SubscribeWaitList";
import TheTeam from "../../components/Website/TheTeam";
import TopNav from "../../components/Website/TopNav";
import { useState } from "react";
import ScrollToTop from "../../components/ScrollToTop";
// import Accordion from "../../components/Accordion";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";

const Terms = () => {
  ScrollToTop();
  const [open, setOpen] = useState("houseForTwo");

  const HandleMenu = () => {
    open === "houseForTwo"
      ? setOpen("houseForTwo active")
      : setOpen("houseForTwo");
  };

  const firstData = [
    {
      title: <h3>1. What is EstateIQ?</h3>,
      body: (
        <>
          <p>
            EstateIQ is a digital solution designed and developed to help
            residents and estate managers of gated communities attain higher
            levels of convenience and efficiency. It is also a simple-to-use
            app, you don’t have to be a techie to use. Regardless of age,
            education level, and occupation, users find the EstateIQ app easy to
            use. The EstateIQ Residents app and EstateIQ Admin app offer users
            five modules for intended actions and results.
          </p>
          <ol>
            <li>
              <b>Access Control</b> EstateIQ offers a secure, convenient,
              flexible way of controlling who has access to your building and
              when access is allowed.
            </li>
            <li>
              <b>Billing and Payment System</b> The collection of fees and dues
              is critical to maintaining infrastructure. EstateIQ makes payments
              convenient, and collections seamless.
            </li>
            <li>
              <b>Residents Collaboration</b> EstateIQ enables collaboration
              among residents as well as with the estate board.
            </li>
            <li>
              <b>Safety and Security</b> Security is among the most notable
              considerations when people opt for gated communities. Estate
              managers can support and strengthen their security architecture
              with EstateIQ
            </li>
            <li>
              <b>Estate Secretariat/Board</b> The estate office can enhance
              productivity and ensure effective communications with residents
              and vendors.
            </li>
          </ol>
        </>
      ),
    },
    {
      title: <h3>2. What are the benefits of creating an EstateIQ account?</h3>,
      body: (
        <>
          <p>If you create an account, you will be able to:</p>
          <ol>
            <li>
              As an estate admin, you will be able to onboard residents of your
              estate so that they can enjoy the numerous services that come with
              using the app – enjoying an additional layer of security and
              keeping your community informed and engaged with real-time
              communication capabilities.
            </li>
            <li>
              As a resident, you will be able to enjoy an additional layer of
              convenience like cutting down waiting times and minimizing human
              errors.
            </li>
          </ol>
        </>
      ),
    },
    {
      title: <h3>3. How can I get the EstateIQ app?</h3>,
      body: (
        <>
          <p>
            EstateIQ is currently available for download on Google Play Store
            and App Store. It is a lightweight mobile application that runs
            seamlessly on Android and iOS platforms and is intuitive to use. We
            have also provided a one-minute video to show you around the
            EstateIQ world. Click the link here.
          </p>
          <ol>
            <li>
              The EstateIQ app can also be launched directly from its website
              (www.estateiq.ng). The web app has been designed to operate like a
              mobile app. With this option, it can always be used, just remember
              to save the URL on the homepage of your device so that you can
              always use it again.
            </li>
            <li>
              In both cases, an active internet connection is required to
              complete the onboarding process, as well as using the app
            </li>
          </ol>
        </>
      ),
    },
    {
      title: (
        <h3>4. What Is Required to Join an Estate on the EstateIQ app?</h3>
      ),
      body: (
        <p>
          A unique EstateIQ ID for your estate is to be provided by your Estate
          Admin, otherwise, you will not be able to initiate the onboarding
          process.
        </p>
      ),
    },
    {
      title: <h3>5. How Quickly Can I Start Using the EstateIQ App?</h3>,
      body: (
        <p>
          As a resident, you can only start enjoying the benefits of the
          features of the app as soon as your Estate Admin approves your request
          to join your estate on EstateIQ. Your Estate Admin is notified as soon
          as you initiate the request to join with the unique EstateIQ ID. If
          you don’t get a quick approval, you should reach out to the admin to
          fast-track your approval.
        </p>
      ),
    },
    {
      title: (
        <h3>6. What is required for the EstateIQ app to work on my device?</h3>
      ),
      body: (
        <p>
          Regardless of the subscription package that your estate has subscribed
          to; paid or free, you will need to have downloaded from Play Store or
          Appstore and installed the app on your mobile device. You will also
          need a functional internet connection. You will need to have the
          latest version of the app.
        </p>
      ),
    },
  ];

  const secondData = [
    {
      title: <h3>1. Do I need to create an account to use EstateIQ?</h3>,
      body: (
        <p>
          Yes, all users must create accounts for EstateIQ services. It is
          important that you provide a valid email address which is used to
          authenticate your request to create an EstateIQ account before you use
          the services. We also use this email to dispatch only EstateIQ-related
          notifications.
        </p>
      ),
    },
    {
      title: <h3>2. How do I create an EstateIQ account?</h3>,
      body: (
        <>
          <p>
            Quickly create an account by clicking ‘SIGN UP’ above and then
            ‘Create account’ in the pop-up box that follows.
          </p>
          <ol>
            <li>
              As an estate admin, download the EstateIQ Admin app from the
              Google Play Store or iOS Appstore. Provide the basic admin and
              estate information
            </li>
            <li>
              As an estate resident, download the EstateIQ Resident app from the
              Google Play store or Appstore. Provide the basic admin and estate
              information. A unique EstateIQ ID for your estate is to be
              provided to you by your Estate Admin, otherwise, you will not be
              able to complete the account creation process.
            </li>
          </ol>
        </>
      ),
    },
    {
      title: <h3>3. How do I change/reset my EstateIQ account password?</h3>,
      body: (
        <p>
          You can reset your password using the ‘forgot password’ link on the
          Sign in page.
        </p>
      ),
    },
    {
      title: <h3>4. How do I sign in/out?</h3>,
      body: (
        <p>
          You can sign out by clicking on the 'Log out' link, which appears when
          you open the profile page at the bottom left of the page.
        </p>
      ),
    },
    {
      title: <h3>5. I am having trouble logging in, what do I do?</h3>,
      body: (
        <p>
          If you are having trouble logging into your account, please check that
          'Caps Lock' is not enabled – all passwords are case-sensitive. If that
          doesn’t work, click ‘‘forgot password” and an OTP will be emailed to
          your registered address for you to reset your password.
        </p>
      ),
    },
    {
      title: <h3>6. How do I update my account details/information?</h3>,
      body: (
        <p>
          You can update your personal bio and contact info details when you
          open the profile page.
        </p>
      ),
    },
    {
      title: (
        <h3>
          7. I am having trouble using my account for access code and other
          services, what do I do? (Authorization & Authentication)
        </h3>
      ),
      body: (
        <p>
          If you are unable to generate an access code or use other services, it
          is likely that your account is yet to be validated by your estate
          admin (please contact your admin) or you are yet to set your address
          on the personal bio page. Please note that without your contact
          address, you will not be able to generate access codes for your
          guests.
        </p>
      ),
    },
  ];

  const thirdData = [
    {
      title: <h3>1. How do I generate an access code?</h3>,
      body: (
        <>
          <ol>
            <li>
              <b>ACCESS CODE</b>
              <p>
                Click the “Generate Access Code” tab on the dashboard and select
                your preferred type of code. There are three choices, depending
                on the situation, namely:
              </p>
            </li>
            <li>
              <b>Private:</b>
              <p>
                If you want to generate an access code for planned visits to
                your home or office situated within the estate,
              </p>
            </li>
            <li>
              <b>Business:</b>
              <p>
                To generate exit passcodes for customers or shoppers that visit
                stores within the estate. In some cases, some estates do not
                allow exit if shoppers or customers are unable to provide exit
                passcodes from the stores that they have visited.
              </p>
            </li>
            <li>
              <b>Waybill:</b>
              <p>
                Generate waybill numbers for items that require authorization
                inbound and/or outbound from the estate.
              </p>
            </li>
          </ol>
          <h3>What do I need to know about the codes?</h3>
          <p>
            <b>a.How long does it take to generate a code?</b>
            <p>
              It takes less than 60 seconds to generate and share the codes with
              your guests. Please make sure that the guest information is filled
              out correctly; these details are also used for security checks by
              your estate's security staff. If you don't do this correctly, your
              guests may have trouble getting through if their answers don't
              match what you provided.
            </p>
          </p>
          <p>
            <b>b. Is the access code reusable?</b>
            <p>No, the access code once it has been used is not reusable.</p>
          </p>
          <p>
            <b>c.Can an access code be revoked?</b>
            <p>
              Yes, the access code, if it has not been used, can be revoked
              before it is verified by the security operatives.
            </p>
          </p>
          <p>
            <b>
              d.What could be the possible causes if I am unable to generate
              access codes?
            </b>
            <ul>
              <li>
                It is likely that your account has not been activated by your
                estate admin. If you have just created a new EstateIQ account,
                please contact your estate admin.
              </li>
              <li>
                It is likely that your account has been deactivated by your
                estate admin, in the case of a security breach traceable to the
                use of your account or in the case of defaulting on your
                obligations as a member of your estate.
              </li>
              <li>
                It is likely that you do not have an active internet connection.
              </li>
              <li>
                It is likely that you have not filled out your home address on
                the profile page. You will not be able to generate an access
                code or exit pass if you have not correctly completed your home
                address.
              </li>
              <li>
                It is also possible that you entered the wrong dates and times
                for the guest’s arrival and departure. Please note that the
                arrival date and time cannot be earlier than the current date
                and time, and neither can the departure date and time be earlier
                than the arrival date and time.
              </li>
            </ul>
          </p>
        </>
      ),
    },
  ];

  return (
    <FAQPage>
      <TopNav />
      <Container>
        <h1>Frequently asked questions</h1>
        <div>
          <p>
            Thank you for choosing the EstateIQ app. We are delighted to have
            you onboard.
          </p>
          <p>Here’s a list of Frequently Asked Questions about EstateIQ. </p>
          <p>
            If you can’t find ananswer to your question(s), please feel free to
            reach out to welcome@estateiq.ng or 09090409121.
          </p>
          <p>
            Enjoy access to EstateIQ services as an estate administrator,
            resident, and security.
          </p>
          <p>Learn more about EstateIQ here welcome@estateiq.ng</p>
          <h2>A. ABOUT ESTATEIQ</h2>
          <Accordion>
            {firstData.map((data) => (
              <AccordionItem header={data.title}>{data.body}</AccordionItem>
            ))}
          </Accordion>

          <h2>B. FIRST THINGS, FIRST</h2>
          <p>
            The first step to enjoying a whole new world that EstateIQ offers is
            to create an account, after downloading the app from Google Play
            Store and iOS App Store.
          </p>
          <h3>Account Creation</h3>

          <Accordion>
            {secondData.map((data) => (
              <AccordionItem header={data.title}>{data.body}</AccordionItem>
            ))}
          </Accordion>

          <h2>C.MODULES</h2>
          <p>
            The EstateIQ app offers users five modules for intended actions and
            results; namely, Access Control, Billing & Payment System, Residents
            Collaboration, Safety & Security and Estate Board.
          </p>
          <Accordion>
            {thirdData.map((data) => (
              <AccordionItem header={data.title}>{data.body}</AccordionItem>
            ))}
          </Accordion>
        </div>
      </Container>
      <Footer />
    </FAQPage>
  );
};

export default Terms;

let FAQPage = styled.section`
  button {
    transform: scale(1);
    transition: 0.4s;
    &:hover {
      transform: scale(0.96) !important;
    }
  }
`;

let Container = styled.section`
  padding: 110px 50px;
  div > * {
    text-align: justify;
  }
  * {
    font-family: DM Sans !important;
  }
  h1 {
    font-weight: bolder;
  }
`;

// import { Accordion, AccordionItem } from "@szhsin/react-accordion";

// export default function Example() {
//   return (
//     <Accordion>
//       <AccordionItem header="What is Lorem Ipsum?">
//         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
//         tempor incididunt ut labore et dolore magna aliqua.
//       </AccordionItem>

//       <AccordionItem header="Where does it come from?">
//         Quisque eget luctus mi, vehicula mollis lorem. Proin fringilla vel erat
//         quis sodales. Nam ex enim, eleifend venenatis lectus vitae, accumsan
//         auctor mi.
//       </AccordionItem>

//       <AccordionItem header="Why do we use it?">
//         Suspendisse massa risus, pretium id interdum in, dictum sit amet ante.
//         Fusce vulputate purus sed tempus feugiat.
//       </AccordionItem>
//     </Accordion>
//   );
// }
